(function($) {

    // Gallery Block
    const galleries = Array.from(document.querySelectorAll('.gallery'));

    galleries.forEach( (gallery) => {
        const tabs = Array.from(gallery.querySelectorAll('.gallery-thumbnail'));
        const panels = Array.from(gallery.querySelectorAll('.gallery-image'));
        const prevArrow = gallery.querySelector('.prev-image');
        const nextArrow = gallery.querySelector('.next-image');
        const thumbnailList = gallery.querySelector('.gallery-thumbnail-list');
        const mediaQuery = window.matchMedia('(min-width: 768px)')


        if(thumbnailList.scrollWidth > thumbnailList.clientWidth){
            thumbnailList.classList.add('scrollable-right');
        }

        const changeTab = (oldTab, newTab) => {
            if(!oldTab || !newTab || (oldTab == newTab)) return;
            newTab.focus();
            newTab.setAttribute('aria-selected', 'true');
            oldTab.removeAttribute('aria-selected');

            let newIndex = tabs.indexOf(newTab);
            let oldIndex = tabs.indexOf(oldTab);

            if(newIndex == 0){
                prevArrow.setAttribute('disabled', '');
            } else {
                prevArrow.removeAttribute('disabled');
            }

            if(newIndex == tabs.length - 1){
                nextArrow.setAttribute('disabled', '');
            } else {
                nextArrow.removeAttribute('disabled');
            }

            panels[oldIndex].setAttribute('data-active-image', false);
            panels[newIndex].setAttribute('data-active-image', true);

            if(mediaQuery.matches){
              thumbnailList.scroll({
                  top: 0,
                  left: newTab.offsetLeft - (newTab.offsetWidth /  2),
                  behavior: 'smooth'
              })
            }
        }

        tabs.forEach( (tab) => {
            tab.addEventListener('click', e => {
                const oldTab = e.target.closest('.gallery-thumbnail-list').querySelector('[aria-selected="true"]');
                const newTab = e.target.closest('.gallery-thumbnail');
                changeTab(oldTab, newTab);
            })

            tab.addEventListener('keydown', e => {
                e.preventDefault();
                let index = tabs.indexOf(e.currentTarget);
                let next = null;
                switch(e.which){
                    case 37: // left
                        next = index - 1;
                        break;
                    case 39: // right
                        next = index + 1;
                        break;
                    case 9:
                        // focus tab element
                        e.target.closest('.gallery').querySelector('.gallery-image[data-active-image="true"]').focus();
                        next = null;
                        break;
                    default:
                        next = null;
                }
                if ( next >= 0 && next < tabs.length && next != null ) {
                    e.preventDefault();
                    changeTab(e.currentTarget, tabs[next]);
                }
            });
        })

        nextArrow.addEventListener('pointerdown', (e) => {
            const oldTab = e.target.closest('.gallery-controls').querySelector('[aria-selected="true"]');
            const newTab = oldTab.nextElementSibling;
            changeTab(oldTab, newTab);
        })
        prevArrow.addEventListener('pointerdown', (e) => {
            const oldTab = e.target.closest('.gallery-controls').querySelector('[aria-selected="true"]');
            const newTab = oldTab.previousElementSibling;
            changeTab(oldTab, newTab);
        })
        
        let timeout;
        thumbnailList.addEventListener('scroll', (e) => {
          console.log(e.target.scrollLeft, e.target.offsetWidth, e.target.scrollWidth)
            if (timeout) {
                window.cancelAnimationFrame(timeout);
            }
        
            timeout = window.requestAnimationFrame(() => {

                if(e.target.scrollLeft + e.target.offsetWidth < e.target.scrollWidth){
                    e.target.classList.add('scrollable-right');
                }
                else {
                    e.target.classList.remove('scrollable-right');
                }

                if(e.target.scrollLeft > 0){
                    e.target.classList.add('scrollable-left');
                }
                else {
                    e.target.classList.remove('scrollable-left');
                }


            });
        })
        // TODO: add window resize event listener
    })

})(jQuery);